/* eslint-disable react/prop-types */
import { Descriptions } from 'antd';
import { useTranslation } from 'react-i18next';
// eslint-disable-next-line max-len
import { type ConfiguratorApplicationEntrypointSpecsFragment } from '../../../../../api/fragments/ConfiguratorApplicationEntrypointSpecs';
import {
    CreateConfiguratorApplicationEntrypointDocument,
    type CreateConfiguratorApplicationEntrypointMutation,
    type CreateConfiguratorApplicationEntrypointMutationVariables,
} from '../../../../../api/mutations/createConfiguratorApplicationEntrypoint';
import {
    UpdateConfiguratorApplicationEntrypointDocument,
    type UpdateConfiguratorApplicationEntrypointMutation,
    type UpdateConfiguratorApplicationEntrypointMutationVariables,
} from '../../../../../api/mutations/updateConfiguratorApplicationEntrypoint';
import { type ConfiguratorApplicationEntrypointSettings } from '../../../../../api/types';
import InputField from '../../../../../components/fields/InputField';
import { type EndpointImplementation } from './types';

const implementation: EndpointImplementation<
    ConfiguratorApplicationEntrypointSpecsFragment,
    ConfiguratorApplicationEntrypointSettings & { configuratorApplicationModuleId?: string }
> = {
    getTitle: t => t('routerDetails:endpoints.ConfiguratorApplicationEntrypoint.title'),
    ViewPanelComponent: ({ endpoint }) => (
        <Descriptions size="small" bordered>
            <Descriptions.Item label="Module">{endpoint.configuratorApplicationModule.displayName}</Descriptions.Item>
            <Descriptions.Item label="Display Name">{endpoint.displayName}</Descriptions.Item>
        </Descriptions>
    ),
    getIsPrivate: () => true,
    FormComponent: () => {
        const { t } = useTranslation(['routerDetails']);

        return (
            <>
                <InputField
                    {...t('routerDetails:endpoints.fields.pathname', { returnObjects: true })}
                    name="pathname"
                />
                <InputField
                    {...t('routerDetails:endpoints.fields.displayName', { returnObjects: true })}
                    name="displayName"
                />
            </>
        );
    },
    getFormInitialValues: endpoint => ({
        pathname: endpoint.pathname,
        displayName: endpoint.displayName,
    }),
    submitCreation: (apolloClient, routerId, { configuratorApplicationModuleId, ...values }) => {
        if (!configuratorApplicationModuleId) {
            throw new Error('Configurator application module is required');
        }

        return apolloClient.mutate<
            CreateConfiguratorApplicationEntrypointMutation,
            CreateConfiguratorApplicationEntrypointMutationVariables
        >({
            mutation: CreateConfiguratorApplicationEntrypointDocument,
            variables: { routerId, configuratorApplicationModuleId, settings: values },
        });
    },
    submitUpdate: (apolloClient, routerId, endpointId, values) =>
        apolloClient.mutate<
            UpdateConfiguratorApplicationEntrypointMutation,
            UpdateConfiguratorApplicationEntrypointMutationVariables
        >({
            mutation: UpdateConfiguratorApplicationEntrypointDocument,
            variables: { routerId, endpointId, settings: values },
        }),
};

export default implementation;
